import * as React from 'react';
import { Checkbox, Popper, Text, TextButton } from '@amzn/storm-ui';
import { FlexContainer } from 'src/commons/components/FlexContainer';
import { Container } from 'src/commons/components/Container';
import { IA2AccountDropdownFilterButton } from '../IA2AccountDropdownFilterButton';
import { useCentricAccountTypeFilter } from '../useAccountTypeFilter';
import { CentricFilterInputProps } from '../IA2Types';
import { useAccountDropdownBundle } from 'src/providers/PantherLocalizationProvider';
import { getCentricAccountTypeFilterLabel } from '../AccountTypeLocalizationKeyMapping';
import {
  StyledButton,
  FilterInputContainer,
  CheckBoxList,
  FilterButtonContainer,
} from '../IA2AccountDropdownFilterInput';

export const CentricAccountDropdownFilterInput: React.FC<
  CentricFilterInputProps
> = ({ accountTypes, onSubmit }) => {
  const {
    accountTypesState,
    filteredAccountTypeCount,
    generateHandleSelection,
    handleClose,
    handleOpen,
    handleSubmit,
    isOpen,
  } = useCentricAccountTypeFilter({ accountTypes, onSubmit });
  const bundle = useAccountDropdownBundle();

  return (
    <Popper
      autoFocus
      trigger={
        <FilterButtonContainer>
          <IA2AccountDropdownFilterButton
            onClick={handleOpen}
            filteredAccountTypeCount={filteredAccountTypeCount}
          />
        </FilterButtonContainer>
      }
      onCloseButtonClick={handleClose}
      isOpen={isOpen}
      position="bottom"
    >
      <FilterInputContainer>
        <Container>
          <Text type="h4">
            {bundle.getMessage('account-dropdown-account-types-label')}
          </Text>
        </Container>
        <CheckBoxList>
          {accountTypesState.map((accountType, index) => {
            return (
              <Checkbox
                key={accountType.type}
                id={accountType.type}
                label={getCentricAccountTypeFilterLabel(
                  accountType.type,
                  bundle,
                )}
                checked={accountType.isSelected}
                onChange={generateHandleSelection(index)}
              />
            );
          })}
        </CheckBoxList>
        <FlexContainer justifyContent="flex-end">
          <TextButton onClick={handleClose}>
            {bundle.getMessage('account-dropdown-cancel-label')}
          </TextButton>
          <StyledButton primary onClick={handleSubmit}>
            {bundle.getMessage('account-dropdown-apply-label')}
          </StyledButton>
        </FlexContainer>
      </FilterInputContainer>
    </Popper>
  );
};
